module.exports = __webpack_public_path__ + "img/icon3.b424fc62.png";